/**
 * Human-readable label for a Signify response path used as a mapping source.
 * Consumers: the product modal's mapping tables and the configuration sidebar's
 * mapping table, both of which list sources by path.
 *
 * Prices are addressed as `price.prices.<PRICE_TYPE_IDENTIFIER>` once
 * `indexSignifyProductPrices` has keyed them, and `formatFieldName` would render
 * that whole path verbatim, so the prefix is dropped before formatting. This is
 * the only place prices are treated specially, and it affects display only —
 * every write and every session override keys off the full path.
 */
import { formatFieldName } from '#types';

const PRICE_PATH_PREFIX = 'price.prices.';

export const formatSignifySourceLabel = (path: string): string =>
  formatFieldName(path.startsWith(PRICE_PATH_PREFIX) ? path.slice(PRICE_PATH_PREFIX.length) : path);
